// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ProgressSpinner_spinner__GoCB1"};